/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import Swiper from 'react-id-swiper';
import {findIndex, propEq} from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Chevron from '../../components/general/navigation-chevron';

const SelectorWrapper = styled(FlexRootWrapper)`
	background: #fff;
	justify-content: space-between;
	border-radius: 8px;
	border: 1px solid #d9d7d7;
	text-align: center;
	padding: 0 19px;


	& .swiper-container {
		min-width: 60px;
		height: ${({button}) => button ? 330 : 400}px;
		min-height: ${({button}) => button ? 330 : 400}px;
		max-height: ${({button}) => button ? 330 : 400}px;
		flex: 0 1 80%;
		overflow: hidden;

		.swiper-slide {
			touch-action: none;
			font-size: 26px;
			font-weight: 600;
			color: #3b3b3b;
			padding: 15px 0;

			& + .swiper-slide {
				${({hasBorders}) => hasBorders
    ? 'border-top: 1px solid #d9d7d7'
    : ''
    }
			}

			&.swiper-slide-active {
				min-height: 63px;
				font-size: 36px;
				font-weight: 700;
				color: #4eb0f3;
			}
		}
	}

	& button {
		margin: 13px 0;
	}
`;

const NavigationButton = styled.a`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 69px;
	${({hasBorders, reversed}) => hasBorders
    ? 'border-' + (reversed ? 'top' : 'bottom') + ': 1px solid #d9d7d7'
    : ''
    }
`;

class InputScrollSelect extends React.Component {
    constructor() {
        super();

        this.swiper = null;
    }

    componentDidUpdate() {
        const active = this.getActiveIndex();
        if (this.swiper && this.swiper.activeIndex !== active) {
            this.swiper.slideTo(active);
        }
    }

    componentWillUnmount() {
        this.swiper.destroy();
    }

    next = () => {
        this.swiper.slideNext();
    };

    prev = () => {
        this.swiper.slidePrev();
    };

    goto = (index) => {
        this.swiper.slideTo(index);
    };

    getActiveIndex = () => {
        if (findIndex(propEq('selected', true))(this.props.items) === -1) {
            const {items, handleChange} = this.props;
            handleChange(items[0].value);
            return 0;

        } else {
            return findIndex(propEq('selected', true))(this.props.items);
        }
    };

    selectItem = () => {
        if (!this.swiper) {
            return;
        }

        const {items, handleChange} = this.props;

        handleChange(items[this.swiper.activeIndex].value);
    };

    render() {
        const {
            items,
            navHasBorders = true,
            itemsHaveBorders = false,
            button = null,
        } = this.props;

        const params = {
            initialSlide: this.getActiveIndex(),
            direction: 'vertical',
            centeredSlides: true,
            mousewheel: true,
            slidesPerView: 7,
            slidesPerGroup: 1,
            loop: false,
            on: {
                slideChange: this.selectItem
            }
        };

        const navParams = {
            thickness: '3px 3px 0 0',
            size: '16',
            color: '#000',
            hoverColor: '#439dd5',
        };

        return (
            <SelectorWrapper hasBorders={itemsHaveBorders} button={React.isValidElement(button)}>
                <NavigationButton hasBorders={navHasBorders} onClick={this.prev}>
                    <Chevron {...navParams} rotate={-45}/>
                </NavigationButton>

                <Swiper {...params} ref={node => node
                    ? this.swiper = node.swiper
                    : null
                }
                >
                    {items.map((item, index) => (
                        <div key={`selector-item-${index}`} onClick={() => this.goto(index)}>
                            {item.value}
                        </div>
                    ))}
                </Swiper>

                <NavigationButton hasBorders={navHasBorders} reversed onClick={this.next}>
                    <Chevron {...navParams} rotate={135}/>
                </NavigationButton>

                {React.isValidElement(button) && button}
            </SelectorWrapper>
        );
    }
}

export default InputScrollSelect;



// WEBPACK FOOTER //
// ./src/components/general/input-scroll-select.js